import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/notifications/dashboard', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCountryMembersSymbol: async (parameter) => {
		return await commonApi().get('/v1/notifications/getCountryMembersSymbol', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	rejectNotification: async (viewModel) => {
		return await commonApi().put('/v1/notifications/rejectNotification', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	changeStatusNotification: async (viewModel) => {
		return await commonApi().post('/v1/notifications/changeStatusNotification', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	getHomeChartItems: async (parameter) => {
		return await commonApi().get('/v1/notifications/getHomeChartItems',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getLatestNotifications: async (parameter) => {
		return await commonApi().get('/v1/notifications/getLatestNotifications', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCRNAttachments: async (parameter) => {
		return await commonApi().get('/v1/notifications/getCRNAttachments', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCRNAttachmentForUnofficialTranslation: async (parameter) => {
		return await commonApi().get('/v1/notifications/getCRNAttachmentForUnofficialTranslation', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCRNNumberForDropdown: async (parameter) => {
		return await commonApi().get('/v1/notifications/getCRNNumberForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCounterNotifications: async (parameter) => {
		return await commonApi().get('/v1/notifications/getCounterNotifications', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getSearchNotifications: async (parameter) => {
		return await commonApi().get('/v1/notifications/getSearchNotifications',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getRelatedNotifications: async (parameter) => {
		return await commonApi().get('/v1/notifications/getRelatedNotifications',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getNotificationLanguages: async (parameter) => {
		return await commonApi().get('/v1/notifications/getNotificationLanguages',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getRejectReason: async (parameter) => {
		return await commonApi().get('/v1/notifications/getRejectReason',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getNotificationDomain: async (parameter) => {
		return await commonApi().get('/v1/notifications/getNotificationDomain',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getProductFreeText: async (parameter) => {
		return await commonApi().get('/v1/notifications/getProductFreeText',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getViewNotification: async (parameter) => {
		return await commonApi().get('/v1/notifications/getViewNotification',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},	
	getParentTitle: async (parameter) => {
		return await commonApi().get('/v1/notifications/getParentTitle',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getParentTitleAndProduct: async (parameter) => {
		return await commonApi().get('/v1/notifications/getParentTitleAndProduct',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	exportToExcel: async (parameters) => {
		return await commonApi().get('/v1/notifications/exportToExcel',
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				var fileName = 'Notifications.xlsx';				
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getProvisionalRecords: async (parameter) => {
		return await commonApi().get('/v1/notifications/getProvisionalRecords', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	hasForum: async (parameter) => {
		return await commonApi().get('/v1/notifications/hasForum', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getReferencedNotifications: async (parameter) => {
		return await commonApi().get('/v1/notifications/getReferencedNotifications', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	checkDMSRecord: async (parameter) => {
		return await commonApi().get('/v1/notifications/checkDMSRecord', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	process: async (viewModel) => {
		return await commonApi().post('/v1/notifications/process', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	toggleBlockedStatus: async (parameter) => {
		return await commonApi().post('/v1/notifications/toggleBlockedStatus', parameter)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
    },
	updateIssuedNotifications: async (viewModel) => {
		return await commonApi().post('/v1/notifications/updateIssuedNotifications', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	getRelatedTradeConcerns: async (parameter) => {
		return await commonApi().get('/v1/notifications/getRelatedTradeConcerns', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}